module.exports = __webpack_public_path__ + "img/sportstrade.99af19df.png";